let customActualClickedCategoryElem;

class CategoryProdSlideService {
  constructor(prodSlideLimit) {
    this.prodSlideLimit = prodSlideLimit;
    this.categoriesNames = [];
    this.allProdSlides;
    this.prodListContainerClassName;
    this.animationTime = 200;
  }

  getAllProdSlide(categoriesSelector) {
    const allProdSlides = document.querySelectorAll(`${categoriesSelector}`);

    if (!allProdSlides || !allProdSlides.length) return;

    this.allProdSlides = allProdSlides;
    return allProdSlides;
  }

  getCategoriesNames(prodSlidesArr) {
    if (!prodSlidesArr || !prodSlidesArr.length) return;

    const arrToReturn = [];
    prodSlidesArr.forEach((slide, idx) => {
      if (idx >= this.prodSlideLimit) return;

      const linkedSlide = slide.getAttribute("data-wsjs-id");

      const categoryObj = {
        title: slide.querySelector(".prod-list-titles-title").innerText,
        linkedSlide,
      };

      arrToReturn.push(categoryObj);
    });

    this.categoriesNames = arrToReturn;
    return arrToReturn;
  }

  insertCategoriesInContainer() {
    if (!this.categoriesNames.length) return;

    const container = document.querySelector(
      ".custom-prodSlide-categories__categories-container"
    );

    this.categoriesNames.forEach((cat) => {
      const span = document.createElement("span");
      span.classList.add("custom-category-option");
      span.setAttribute("linked-slide", cat.linkedSlide);
      span.innerHTML = cat.title;
      container.appendChild(span);
    });
  }

  createContainer(containerToAppendSelector, className, content) {
    const hasThisContainer = document.querySelector(`.${className}`);

    if (!containerToAppendSelector || hasThisContainer) return;

    const div = document.createElement("div");
    div.classList.add(className);

    if (content) {
      div.innerHTML = content;
    }

    const containerToAppend = document.querySelector(
      `.${containerToAppendSelector}`
    );

    if (!containerToAppend) return;
    containerToAppend.appendChild(div);
  }

  /**
   * @param {string} className
   */
  set setProdListContainerClassName(className) {
    return (this.prodListContainerClassName = className);
  }

  insertProdSlides() {
    if (!this.allProdSlides.length) return;

    const container = this.getProdSlideContainer();

    if (!container) return;

    this.allProdSlides.forEach((slide, idx) => {
      if (idx >= this.prodSlideLimit) return;

      slide.setAttribute("custom-prodSlide-animation", "");
      slide.setAttribute("custom-prodSlide-state", "enabled");

      if (idx > 0) slide.setAttribute("custom-prodSlide-state", "disabled");

      container.appendChild(slide);
    });
  }

  getProdSlideContainer() {
    if (!this.prodListContainerClassName) return;

    return document.querySelector(`.${this.prodListContainerClassName}`);
  }

  createClickCategoryEvent() {
    if (!this.categoriesNames || !this.categoriesNames.length) return;

    const allCategoriesElms = document.querySelectorAll(
      ".custom-prodSlide-categories__categories-container .custom-category-option"
    );

    allCategoriesElms.forEach((elm) => {
      elm.addEventListener("click", (e) => {
        const linkedSlide = e.target.getAttribute("linked-slide");

        this.selectedCategoryAnimationLine(e.target);

        this.refreshProdSlides();

        this.activeSlide(linkedSlide);

        this.resizeWindow();
      });
    });
  }

  activeSlide(slide) {
    const elm = document.querySelector(
      `.custom-prodSlide-categories__prodSlides-container [data-wsjs-id="${slide}"]`
    );

    elm.setAttribute("custom-prodslide-animation", "show");

    setTimeout(() => {
      elm.setAttribute("custom-prodslide-state", "enabled");
    }, this.animationTime);
  }

  refreshProdSlides() {
    const allSlides = document.querySelectorAll(
      `.custom-prodSlide-categories__prodSlides-container [data-wsjs-sectype="prodSlide"]`
    );

    allSlides.forEach((slide) => {
      slide.setAttribute("custom-prodslide-animation", "hide");

      setTimeout(() => {
        slide.setAttribute("custom-prodslide-state", "disabled");
      }, this.animationTime);
    });
  }

  resizeWindow() {
    try {
      setTimeout(() => {
        let event = new Event("resize");
        window.dispatchEvent(event);
      }, this.animationTime + 100);
    } catch (e) {}
  }

  selectedCategoryAnimationLine(el) {
    const indicator = document.getElementById("indicatorProdlistClone");

    indicator.style.left = el.offsetLeft + "px";
    indicator.style.width = el.offsetWidth + "px";
    
    customActualClickedCategoryElem = el;
  }
}

function createHomeCategoryProdlist() {
  const categoryProdSlideService = new CategoryProdSlideService(6);

  // obtem todos os prodslide
  const getAllProdSlide = categoryProdSlideService.getAllProdSlide(
    '[data-wsjs-sectype="prodSlide"]'
  );

  // pega o nome das categorias do prodslide
  categoryProdSlideService.getCategoriesNames(getAllProdSlide);

  // adiciona o container das categorias na div pai
  categoryProdSlideService.createContainer(
    "custom-prodSlide-categories",
    "custom-prodSlide-categories__categories-container",
    '<div id="indicatorProdlist"></div><div id="indicatorProdlistClone"></div>'
  );

  // insere as categorias no container correto
  categoryProdSlideService.insertCategoriesInContainer();

  // adiciona container dos slides na div pai
  categoryProdSlideService.createContainer(
    "custom-prodSlide-categories",
    "custom-prodSlide-categories__prodSlides-container"
  );

  // seta a variavel com o nome da classe do container do prodSlide
  categoryProdSlideService.setProdListContainerClassName =
    "custom-prodSlide-categories__prodSlides-container";

  // insere os prodSlide dentro da nova div customizada
  categoryProdSlideService.insertProdSlides();

  // adiciona o evento de click nas categorias
  categoryProdSlideService.createClickCategoryEvent();

}

function categoryLineAnimationProdlist() {
  const nav = document.querySelector(
    ".custom-prodSlide-categories__categories-container"
  );
  const indicator = document.getElementById("indicatorProdlist");
  const indicatorClone = document.getElementById("indicatorProdlistClone");
  const itens = nav.querySelectorAll(".custom-category-option");

  if (itens.length) {
    customActualClickedCategoryElem = itens[0];

    if (!customActualClickedCategoryElem) {
      return;
    }

    indicatorClone.style.width =
      customActualClickedCategoryElem.offsetWidth + "px";
  }

  function moveIndicator(el) {
    indicator.style.left = el.offsetLeft + "px";
    indicator.style.width = el.offsetWidth + "px";

    if (customActualClickedCategoryElem !== el) {
      indicatorClone.style.width = "0";
    }
  }

  itens.forEach((item) => {
    item.addEventListener("mouseenter", () => moveIndicator(item));
  });

  nav.addEventListener("mouseleave", () => {
    indicator.style.width = "0";
    if (customActualClickedCategoryElem) {
      indicatorClone.style.width =
        customActualClickedCategoryElem.offsetWidth + "px";
    }
  });
}

// "Produtos por linha" (config.json) é 5 nos carrosséis de produto da home
// (data-wsjs-slide="...slides.perView: 5..." em cada âncora). Abaixo de
// 1300px isso aperta demais os cards — usa o breakpoints nativo do
// KeenSlider (window.matchMedia por baixo) via slider.update(), já que o
// parser data-wsjs-slide (getWsData, wsapi3-main.js) faz optKey.split(':')
// sem limite e quebra numa media query com ':' dentro (ex.:
// "(max-width: 1299px)") — não dá pra expressar breakpoints na sintaxe
// data-wsjs-slide, só programaticamente depois que o slider já existe.
// wsMain['prod-slides'] é o array com toda instância KeenSlider criada por
// wsapi3-prod-list.js (inclusive as escondidas pelas abas do
// createHomeCategoryProdlist acima — o listener de breakpoint continua
// ativo enquanto o slider não é destruído).
//
// slider.update(t) do KeenSlider NÃO faz merge com as options ativas atuais
// — ele recombina a partir de um base próprio + t, então passar só
// {breakpoints} pra update() perde perView/arrows/spacing originais e a
// media query acima de 1300px (quando nenhum breakpoint bate) cai pro
// default interno da lib (perView:1, carrossel quebrado). Por isso
// reenviamos slider.options inteiro (o objeto completo já montado no
// createSlide) junto com o breakpoints novo.
function capProdSlidesPerViewBelow1300() {
  const MEDIA_QUERY = "(max-width: 1299px)";
  const CAPPED_PER_VIEW = 4;

  (wsMain["prod-slides"] || []).forEach((slider) => {
    if (!slider || !slider.options || !slider.options.slides) return;
    if (Number(slider.options.slides.perView) !== 5) return;

    slider.update({
      ...slider.options,
      breakpoints: {
        ...(slider.options.breakpoints || {}),
        [MEDIA_QUERY]: { slides: { perView: CAPPED_PER_VIEW } },
      },
    });
  });
}

try {
  isReady("categorias", categoryLineAnimationProdlist);
} catch {}

try {
  isReady("product-list", createHomeCategoryProdlist);
} catch (error) {}

try {
  isReady("product-list", capProdSlidesPerViewBelow1300);
} catch (error) {}
